// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3KA42","title":"Header_title__2VVlT","left":"Header_left__1pEAh","clinicName":"Header_clinicName__2yYaJ"};